import Content from "./components/MainScreen/Content";
import Header from "./components/UI/Header";
import Footer from "./components/UI/Footer";
import BottomBar from "./components/UI/BottomBar";
//import FAQ from "./components/MainScreen/FAQ";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
//import AdSense from "react-adsense";
import "./App.css";
//import Share from "./components/MainScreen/Share";
import SideBar from "./components/UI/SideBar";

function App() {
	return (
		<div className="App">
			<Header />
			<SideBar />
			<BottomBar />
			<div className="breadcrumb-main">
				<Breadcrumbs
					style={{ fontFamily: "Poppins" }}
					aria-label="breadcrumb"
				>
					<Link underline="hover" color="inherit" href="/">
						<span className="breadcrumb-link">Home</span>
					</Link>
					<Link
						underline="hover"
						color="inherit"
						href="#"
					>
						<span className="breadcrumb-link">Graphic Tools</span>
					</Link>
					<Typography
						style={{ fontFamily: "Poppins" }}
						color="text.primary"
					>
						<span className="breadcrumb-link">
							<b>Image Resizer</b>
						</span>
					</Typography>
				</Breadcrumbs>
			</div>
			<div>
				<Content />
				{/* <AdSense.Google
					client="ca-pub-7292810486004926"
					slot="7806394673"
					style={{ display: "block" }}
					format="auto"
					responsive="true"
					layoutKey="-gw-1+2a-9x+5c"
				/> */}

				{/* <FAQ /> */}
				
			</div>
			{/* <AdSense.Google
				client="ca-pub-7292810486004926"
				slot="7806394673"
				style={{ display: "block" }}
				format="auto"
				responsive="true"
				layoutKey="-gw-1+2a-9x+5c"
			/> */}
			{/* <Share /> */}
			<Footer />
		</div>
	);
}

export default App;
